export default function initSearchDownloads() {

    if (!document.body.classList.contains('post-type-archive-download')) {
        return;
    }

    const customInput = document.getElementById('custom-search-input');
    const aspContainer = document.querySelector('.c-grid-area__asp-hidden');

    // Procura o input de texto original (escondido) do Ajax Search Pro
    const aspHiddenInput = aspContainer?.querySelector('input.orig');

    // Seletores adicionados para manipular os filtros
    const customCheckboxes = document.querySelectorAll('.c-filter-item input');
    const aspCheckboxes = document.querySelectorAll('.c-grid-area__asp-hidden input[type="checkbox"]');
    const countDisplay = document.querySelector('.js-filter-count');

    const aspId = parseInt(aspContainer?.getAttribute('data-asp-id'), 10);

    if (!customInput || !aspHiddenInput || Number.isNaN(aspId)) return;

    let debounceTimer;

    customInput.addEventListener('input', (event) => {
        const searchTerm = event.target.value;

        clearTimeout(debounceTimer);

        debounceTimer = setTimeout(() => {

            // REGRA DE NEGÓCIO: Se o usuário digitou algo, limpamos os filtros ativos.
            if (searchTerm.trim().length > 0) {
                let hasCleared = false;

                // 1. Zera a nossa UI visual (BEM)
                customCheckboxes.forEach(cb => {
                    if (cb.checked) {
                        cb.checked = false;
                        hasCleared = true;
                    }
                });

                // 2. Zera os inputs escondidos do ASP e dispara o evento de change
                // para que o state interno do plugin seja atualizado
                if (hasCleared) {
                    aspCheckboxes.forEach(cb => {
                        if (cb.checked) {
                            cb.checked = false;
                            // Evento silencioso, não dispara busca do ASP ainda
                            cb.dispatchEvent(new Event('change', { bubbles: true }));
                        }
                    });

                    // 3. Atualiza o contador visual na interface
                    if (countDisplay) {
                        countDisplay.textContent = '0';
                    }
                }
            }

            // 4. Copia o texto do nosso input para o input do ASP
            aspHiddenInput.value = searchTerm;

            // 5. Avisa o plugin que o texto mudou
            aspHiddenInput.dispatchEvent(new Event('input', { bubbles: true }));

            // 6. Dispara a atualização do grid com a API do ASP
            // Isso fará uma única requisição com os filtros limpos e o novo termo de busca
            if (window.ASP && window.ASP.api) {
                window.ASP.api(aspId, 'search');
            }

        }, 500);
    });
}
